// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"TestimonialsGroup_testimonial__YwKQm","TestimonialGroup":"TestimonialsGroup_TestimonialGroup__9fKAE","testimonialGroup":"TestimonialsGroup_testimonialGroup__kTy4z"};